module.exports = __webpack_public_path__ + "img/plan_2.ab7a267.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/type-setting/plan_2.svg
// module id = MFqm
// module chunks = 1